import { Dispatch, useState, SetStateAction } from 'react';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

import type { RootState, AppDispatch } from '../redux/configStore';

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export const useModal = (
  defaultState = false
): {
  visible: boolean;
  onOpenModal: () => void;
  onCloseModal: () => void;
  setVisible: Dispatch<SetStateAction<boolean>>;
} => {
  const [visible, setVisible] = useState(defaultState);
  const onOpenModal = () => {
    setVisible(true);
  };
  const onCloseModal = () => {
    setVisible(false);
  };
  return {
    visible,
    onOpenModal,
    onCloseModal,
    setVisible,
  };
};
